import React from "react";
import { indianCurrencyFormat, convertNumberToWords } from "../../../utils/utils";
import { byPassOTP, edcReTriggers} from '../../../store/actions/byPassOTP';
import MobilePopUp from "../../../components/MobilePopUp/MobilePopUp";
import { connect } from "react-redux";
import deleteButton from "../../../Assets/images/delete_small_icon.svg";
import { deletePaymentMethodMcustomerAPI } from "../../../store/actions/paymentActions";

class PaymentDetails extends React.Component {
    constructor(props) {
        super(props);
        this.totalPremiumPayable = props.paymentDetails['totalPremiumPayable'];
        this.state = {
            ShowEdcReTriggerPopup: false
        };
    }
    getRemainingPayment = () => {
        return (
            this.totalPremiumPayable - this.getTotalPaid()
        );
    }
    getValidRemainingPayment = () => {
        return (
            this.totalPremiumPayable - this.getTotalValidPaid() - 10
        );
    }
    getNameFromKey = (obj, key) => {
        let option = obj.filter((item) => {
            return item.key === key;
        })
        return option[0] ? option[0].name : ''
    }
    getTotalPaid = () => {
        let totalPaid = 0;
        if (this.props.paymentDetails.methodsOfPayments &&
            this.props.paymentDetails.methodsOfPayments.length) {
            this.props.paymentDetails.methodsOfPayments.forEach((item, index) => {
                if (item.txAmount && (item.txPaymentStatus === 'COMPLETED' || item.txPaymentStatus === 'CREATED')) {
                    totalPaid = totalPaid + item.txAmount
                }

            })
            return totalPaid;
        }
        else {
            return 0;
        }
    }
    getTotalValidPaid = () => {
        let totalPaid = 0;
        if (this.props.paymentDetails.methodsOfPayments &&
            this.props.paymentDetails.methodsOfPayments.length) {
            this.props.paymentDetails.methodsOfPayments.forEach((item, index) => {
                if (item.txAmount && item.txPaymentStatus === 'COMPLETED') {
                    totalPaid = totalPaid + item.txAmount
                }

            })
            return totalPaid;
        }
        else {
            return 0;
        }
    }
    getIconClass = (type) => {
        switch (type.paymentMethod) {
            case 'CHEQUE':
                return 'ic_cheque';
            case 'DEMAND_DRAFT':
                return 'ic_demand_draft';
            case 'NEFT':
                return 'ic_neft';
            case 'PAYMENT_AT_BANK_CASH':
                return 'ic_bank_cash';
            case 'PAYMENT_AT_BANK_CHEQUE':
                return 'ic_bank_cheque';
            case 'ONLINE_BILL_DESK':
                return 'ic_billdesk';
            case 'ONLINE_LINK':
                return 'ic_online_link';
            case 'CASH':
                return 'ic_cash';
        }
    }
    getPaymentStatusLabel = (status) => {
        switch (status) {
            case 'COMPLETED':
                return 'Payment Success';
            case 'PENDING':
                return 'Payment Pending';
            case 'FAILED':
                return 'Payment Failed';
            case 'EXPIRED':
                return 'Payment Link Expired';
            case 'CREATED':
                return 'Online Payment In Progress';
            default:
                return '';
        }
    }
    getLeftAmount = () => {
        let amountLeft = this.totalPremiumPayable - this.getTotalPaid();
        amountLeft = amountLeft < 0 ? 0 : amountLeft;
        return indianCurrencyFormat(amountLeft);
    }

    deletePayMethod = (id) => {
        this.props.deletePaymentMethodMcustomerAPI(this.props.proposalData.proposalNumber, id,  ()=>{});
    }

    //function to display delete icon to delete the added payment
    renderDeletePay = (item) => {
        if(item.paymentMethod === 'EASY_PAY' && item.txPaymentStatus !== 'COMPLETED') {
            return (
                <span
                    className='price delete-pay'
                    onClick={() => this.deletePayMethod(item.id)}
                >
                    <img src={deleteButton} alt='delete pay option'></img>
                </span>
            );
        }
    };

    renderAddedPaymentMethod = () => {
        if (this.props.paymentDetails.methodsOfPayments &&
            this.props.paymentDetails.methodsOfPayments.length) {
            return (
                <>
                    <div className="payable-wrapper mt-10 heightAuto">
                        <div className="payable-heading">
                            Total Premium Paid
                        </div>
                        <div className="payable-amount">
                            {
                                this.getValidRemainingPayment() <= 0 ?
                                    <span className="check_icon" />
                                    : <span className="error_icon" />
                            }
                            ₹ {indianCurrencyFormat(this.getTotalPaid())}

                        </div>
                        {
                            this.props.paymentDetails.methodsOfPayments &&
                            this.props.paymentDetails.methodsOfPayments.length &&
                            this.props.paymentDetails.methodsOfPayments.map((item, index) => {
                                return (
                                    <div>
                                        <div key={index} className={`quick_links${index === 0 ? ' first-one' : ''}`}>
                                            <div className="action_link" >
                                                {/* <span className={`ic-payement-type-links ${this.getIconClass(item)}`} /> */}
                                                <span>{item.paymentMethod}</span>
                                            </div>
                                            <div className="amount">
                                                {
                                                    item.paymentMethod === 'ONLINE_LINK' && this.getPaymentStatusLabel(item.txPaymentStatus) &&
                                                    <span className={item.txPaymentStatus === 'EXPIRED' ? 'expired_btn' : 'resend_btn'}>
                                                        {this.getPaymentStatusLabel(item.txPaymentStatus)}
                                                    </span>
                                                }
                                                {this.renderDeletePay(item)}
                                                <span className="price">
                                                    <span className="rupee_icon">₹ </span>
                                                    {indianCurrencyFormat(item.txAmount)}
                                                </span>

                                            </div>

                                        </div>
                                        {
                                            item.txReferenceNo &&
                                            <div>
                                                Transaction Id: {item.txReferenceNo}
                                            </div>
                                        }
                                    </div>
                                )
                            })
                        }
                        <div className="amount-in-words remaining-amount">
                            <span className="amount-value">  ₹ {this.getLeftAmount()} </span>
                            <span className="amount-text"> Balance amount to be paid: </span>
                        </div>

                    </div>


                </>

            )
        }
        else {
            return null;
        }
    }
    isPaymentNotAvailable = () => {
        return ((this.props.paymentDetails['methodsOfPayments'] && this.props.paymentDetails['methodsOfPayments'].length >= 4) ||
            this.getRemainingPayment() <= 0)
    }
    renderRenewalCheck = () => {
        if (this.props.paymentDetails.renewal &&
            this.props.paymentDetails.renewal.paymentMode) {
            const paymentMode = this.props.paymentDetails?.renewal?.paymentMode;
            const isEMandate =
                paymentMode === 'E_MANDATE' || paymentMode === 'E_MANDATE_ONLY';
            if (isEMandate) {
                const { reciept, mandateTrackerStatus } = this.props?.paymentDetails?.renewal;
                //if (reciept && mandateTrackerStatus === 'ACTIVATED') {
                const isDebitOrNetBankingSuccess =
                    reciept?.debitAndNetBankingDetails?.authStatus === '0300';
                    const isCreditCardActive =
                    reciept?.creditCardDetails?.status?.toLowerCase() === 'active';
                    if (reciept && (isDebitOrNetBankingSuccess || isCreditCardActive)) {
                    return (<span className="check_icon" />)
                }
                else {
                    return null;
                }
            }
            else {
                return (<span className="check_icon" />)
            }
        }
        else {
            return null;
        }
    }
    renderENatch = () => {
        return (
            <>
                <span>Renewal Payment Details{
                    this.props.paymentDetails.renewal &&
                    this.props.paymentDetails.renewal.paymentMode &&
                    <p className="renewal-mode">({this.props.paymentDetails.renewal.paymentMode==="E_MANDATE"?"E_NACH":this.props.paymentDetails.renewal.paymentMode})</p>
                }
                    {
                        this.renderRenewalCheck()
                    }
                </span>
            </>
        )
    }
    bypassHandler =()=>{
        const pn = this.props.proposalData.proposalNumber;
           this.props.byPassOTP(pn)
    }
    paymentMethod=(data)=>{
        return ((data.paymentMethod === "NEFT") || (data.paymentMethod === "ONLINE_BILL_DESK"));
    }

    edcReTrigger = () =>{
        this.setState({
            ShowEdcReTriggerPopup: true
        })
    }
    edcReTriggerNo = () =>{
        const proposalNumber = this.props.proposalData.proposalNumber;
        this.props.edcReTriggers(proposalNumber, "False")
        this.setState({ShowEdcReTriggerPopup: false})
    }
    edcReTriggerYes = () =>{
        const proposalNumber = this.props.proposalData.proposalNumber;
        this.props.edcReTriggers(proposalNumber, "True")
        this.setState({ShowEdcReTriggerPopup: false})
    }
    render() {
        const methodsOfPayments =   this.props.paymentDetails.methodsOfPayments.length && this.props.paymentDetails.methodsOfPayments; 
        const payment = methodsOfPayments &&  methodsOfPayments?.find(this.paymentMethod)
        const D2C = this.props.proposalData.channelInfo.channelName === "D2C";
        const consentNotRequired = this.props.proposalData?.consentDetails?.customerConsentRequired !== true
        const consentNotVerified = this.props.proposalData?.consentDetails?.verified !== true
        const consentVerified = this.props.proposalData?.consentDetails?.verified === true
        const consentAccepted = this.props.proposalData?.consentDetails?.accepted === true
        const isEDCOpted = this.props.proposalData?.edcDetails?.isEDCOpted === true
        
        

        
        const showOtpNotVerifiedMessage = (
            (!this.props.paymentDetails.otpVerified && consentNotRequired) ||
            (!consentNotRequired && consentNotVerified)
        ) && !D2C;
        return (
        <>
            {/* Always Render This Block */}
            {(isEDCOpted) && <div className="payable-wrapper diplayFlex">
                <div className="payable-heading2">
                    Would you like to re-send EDC payment request ?
                </div>

                <div className={`payable-amount`}>
                    <button 
                    className={`edc-trigger ${(consentVerified && consentAccepted) ? 'btdisabled' : ''}`}
                    onClick={this.edcReTrigger}>
                        EDC Re-trigger
                    </button>
                </div>
            </div>
            }

            {this.state.ShowEdcReTriggerPopup && (
                <MobilePopUp
                   cssClass="retrigger-Popup"
                    onClose={() => {
                        this.setState({ShowEdcReTriggerPopup: false});
                    }}
                >
                <div className="reTriggerPopup">
                    <div>
                        <div className="h3 reTriggerPopup-wrapper-text">
                            Do you want to do the payment via UPI ?
                        </div>
                    </div>
                    <div className="reTriggerPopup-wrapper">
                        <button
                            className="delte-no-btn custom-button"
                            onClick={() => this.edcReTriggerYes()}
                        >
                            YES
                        </button>
                        <button
                            className="delte-yes-btn custom-button"
                            onClick={() => this.edcReTriggerNo()}
                        >
                            NO
                        </button>
                    </div>
                </div>
                </MobilePopUp>
            )}



            {showOtpNotVerifiedMessage ? (
                <>
                    <h2>OTP Not Verified</h2>
                </>
            ) : (
                <>
                 {D2C && <button className="searchbt"  onClick={this.bypassHandler}>Bypass OTP</button>}
                    <div className={`PaymentDetailsForm ${this.props.cssClass} ${this.props.locked ? 'lockedForm' : ''}`}>
                        <div className="payable-wrapper">
                            <div className="payable-heading">
                                Total Premium Payable
                            </div>
                            <div className="payable-amount">₹ {indianCurrencyFormat(this.totalPremiumPayable)}
                                <label>(TID)</label>
                            </div>
                            <div className="amount-in-words">{convertNumberToWords(this.totalPremiumPayable)}</div>

                        </div>

                        <div className="payable-wrapper">
                            <div className="payable-heading">
                                Total Premium Payable
                            </div>
                            <div className="payable-amount">₹ {indianCurrencyFormat(this.totalPremiumPayable)}
                                <label>(Inclusive of GST)</label>
                            </div>
                            <div className="amount-in-words">{convertNumberToWords(this.totalPremiumPayable)}</div>

                        </div>
                        {
                            this.renderAddedPaymentMethod()
                        }
                        {
                            this.props.paymentDetails.payer &&
                            <div className="actions">
                                <div className="heading">Payor <span>({this.props.paymentDetails.payer.payerType})</span></div>
                                <div className="description_actions payor-name">
                                    <span>{this.props.paymentDetails.payer.fullName}</span>

                                </div>
                                {this.props.paymentDetails.payer.payerType === "OTHER" &&
                                    <div className="main_container inner-section">
                                        <div className="list_proposal">
                                            <div className="label">Pan Number</div>
                                            <div className="value">
                                                {this.props.paymentDetails.payer.panNumber}
                                            </div>
                                        </div>
                                        <div className="list_proposal">
                                            <div className="label">Relation Ship</div>
                                            <div className="value">
                                                {this.props.paymentDetails.payer.relationShip}
                                            </div>
                                        </div>
                                        <div className="list_proposal">
                                            <div className="label">Submit Form60:</div>
                                            <div className="value">
                                                {this.props.paymentDetails.payer.submitForm60 ? "Yes" : "No"}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        <div className="actions">
                            <div className="description_actions">
                                {
                                    this.renderENatch()
                                }
                            </div>
                        </div>
                        <div className="actions">
                            <div className="description_actions">
                                <span>NEFT Details {this.props.paymentDetails.neftDetails && <span className="check_icon" />}</span>

                            </div>
                            {
                                this.props.paymentDetails.neftDetails &&
                                <div className="main_container inner-section">
                                    <div className="list_proposal">
                                        <div className="label">Account Holder Name</div>
                                        <div className="value">
                                            {this.props.paymentDetails.neftDetails.accHolderName}
                                        </div>
                                    </div>
                                    <div className="list_proposal">
                                        <div className="label">Account Number</div>
                                        <div className="value">
                                            {this.props.paymentDetails.neftDetails.accountNumber}
                                        </div>
                                    </div>
                                    <div className="list_proposal">
                                        <div className="label">Account Type</div>
                                        <div className="value">
                                            {this.props.paymentDetails.neftDetails.accountType}
                                        </div>
                                    </div>
                                    <div className="list_proposal">
                                        <div className="label">Bank Name</div>
                                        <div className="value">
                                            {this.props.paymentDetails.neftDetails.bankName}
                                        </div>
                                    </div>
                                    <div className="list_proposal">
                                        <div className="label">Branch Name</div>
                                        <div className="value">
                                            {this.props.paymentDetails.neftDetails.branchName}
                                        </div>
                                    </div>
                                    <div className="list_proposal">
                                        <div className="label">IFSC Code</div>
                                        <div className="value">
                                            {this.props.paymentDetails.neftDetails.ifscCode}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                    </div>
                </>
            )}
        </>
        );
        
        // if (((!this.props.paymentDetails.otpVerified && consentNotRequired) || (!consentNotRequired && consentNotVerified)) && !(this.props.proposalData.channelInfo.channelName === "D2C")) {
        //     return (
        //     <>
        //         <div className="payable-wrapper diplayFlex">
        //             <div className="payable-heading2">
        //             Would you like to re-send EDC payment request
        //             </div>
                    
        //             <div className="payable-amount">
        //                 <button className="edc-trigger" onClick={this.searchIFSC}>
        //                     EDC Re-trigger
        //                 </button>
        //             </div>
        //         </div>
        //         <h2>OTP Not Verified</h2>
        //     </>
        //     )
        // } else {
        //     return (
                
        //     );
        // }

    }
}

// export default PaymentDetails;
const mapStateToProps = (state) => {
    return {
      state:state,
      authentication:state.authentication
   };
  };
export default connect(mapStateToProps, {
    byPassOTP,
    edcReTriggers,
    deletePaymentMethodMcustomerAPI
  })(PaymentDetails);



